module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/department/department-grid/department-grid.component.css
// module id = ./src/app/masters/department/department-grid/department-grid.component.css
// module chunks = main